import onHoldRingtone from "../../../../assets/rings/calls/on-hold-ringtone.mp3";
import showSuspenseWaiting from "../../../../assets/rings/calls/show-suspense-waiting.mp3";
import waitingRingtone from "../../../../assets/rings/calls/waiting-ringtone.mp3";
import vintageTelephoneRingtone from "../../../../assets/rings/calls/vintage-telephone-ringtone.mp3";
import marimbaRingtone from "../../../../assets/rings/calls/marimba-ringtone.mp3";
import marimbaWaitingRingtone from "../../../../assets/rings/calls/marimba-waiting-ringtone.mp3";
import officeTelephoneRing from "../../../../assets/rings/calls/office-telephone-ring.mp3";
import toyTelephoneRing from "../../../../assets/rings/calls/toy-telephone-ring.mp3";
import messageHappyBellAlert from "../../../../assets/rings/messages/happy-bell-alert.mp3";
import softwareInterfaceStart from "../../../../assets/rings/messages/software-interface-start.mp3";
import digitalQuickTone from "../../../../assets/rings/messages/digital-quick-tone.mp3";
import messagePopAlert from "../../../../assets/rings/messages/message-pop-alert.mp3";
import mysteryAlert from "../../../../assets/rings/messages/mystery-alert.mp3";
import doubleBeepToneAlert from "../../../../assets/rings/messages/double-beep-tone-alert.mp3";
import confirmationTone from "../../../../assets/rings/messages/confirmation-tone.mp3";
import notificationHappyBellAlert from "../../../../assets/rings/notifications/happy-bell-alert.mp3";
import retroClick from "../../../../assets/rings/notifications/retro-click.mp3";
import notificationMessagePopAlert from "../../../../assets/rings/notifications/message-pop-alert.mp3";
import cookingStopwatchAlert from "../../../../assets/rings/notifications/cooking-stopwatch-alert.mp3";
import { AudioChannel, AudioTone } from "../types";

const silentTone: AudioTone = {
  id: "silent",
  label: "Silent",
};

export const AUDIO_TONES_BY_CHANNEL: Record<AudioChannel, AudioTone[]> = {
  call: [
    {
      id: "vintage-telephone-ringtone",
      label: "Vintage Telephone",
      description: "Default",
      src: vintageTelephoneRingtone,
    },
    {
      id: "office-telephone-ring",
      label: "Office Telephone",
      src: officeTelephoneRing,
    },
    {
      id: "marimba-ringtone",
      label: "Marimba",
      src: marimbaRingtone,
    },
    {
      id: "marimba-waiting-ringtone",
      label: "Marimba Waiting",
      src: marimbaWaitingRingtone,
    },
    {
      id: "waiting-ringtone",
      label: "Waiting",
      src: waitingRingtone,
    },
    {
      id: "on-hold-ringtone",
      label: "On Hold",
      src: onHoldRingtone,
    },
    {
      id: "show-suspense-waiting",
      label: "Suspense Waiting",
      src: showSuspenseWaiting,
    },
    {
      id: "toy-telephone-ring",
      label: "Toy Telephone",
      src: toyTelephoneRing,
    },
    silentTone,
  ],
  message: [
    {
      id: "message-pop-alert",
      label: "Message Pop",
      description: "Default",
      src: messagePopAlert,
    },
    {
      id: "digital-quick-tone",
      label: "Digital Quick",
      src: digitalQuickTone,
    },
    {
      id: "double-beep-tone-alert",
      label: "Double Beep",
      src: doubleBeepToneAlert,
    },
    {
      id: "confirmation-tone",
      label: "Confirmation",
      src: confirmationTone,
    },
    {
      id: "happy-bell-alert",
      label: "Happy Bell",
      src: messageHappyBellAlert,
    },
    {
      id: "software-interface-start",
      label: "Interface Start",
      src: softwareInterfaceStart,
    },
    {
      id: "mystery-alert",
      label: "Mystery",
      src: mysteryAlert,
    },
    silentTone,
  ],
  notification: [
    {
      id: "happy-bell-alert",
      label: "Happy Bell",
      description: "Default",
      src: notificationHappyBellAlert,
    },
    {
      id: "message-pop-alert",
      label: "Message Pop",
      src: notificationMessagePopAlert,
    },
    {
      id: "retro-click",
      label: "Retro Click",
      src: retroClick,
    },
    {
      id: "cooking-stopwatch-alert",
      label: "Stopwatch",
      src: cookingStopwatchAlert,
    },
    silentTone,
  ],
};

export const DEFAULT_AUDIO_TONE_BY_CHANNEL: Record<AudioChannel, AudioTone["id"]> = {
  call: "vintage-telephone-ringtone",
  message: "message-pop-alert",
  notification: "happy-bell-alert",
};
